module.exports = __webpack_public_path__ + "img/end_02.fd3d168e.png";